import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiresApproval?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiresApproval = true }) => {
  const { user, loading, isApproved, hasTemporaryPassword } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // If not logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If user has temporary password and not on force password change page, redirect there
  if (hasTemporaryPassword && location.pathname !== '/force-password-change') {
    return <Navigate to="/force-password-change" replace />;
  }

  // If user is not approved and requires approval, redirect to approval pending
  if (requiresApproval && !isApproved && location.pathname !== '/approval-pending') {
    return <Navigate to="/approval-pending" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 